// active jquery no conflict
$ = jQuery.noConflict();